// extracted by mini-css-extract-plugin
module.exports = {"list":"_1c9529d521--list--i0LQt","list-item":"_1c9529d521--list-item--RN4oZ"};